<template>
  <div>
    <h1>系统使用说明文档</h1>

  </div>
</template>

<script>
export default {
  name: 'Help',
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/manager/components/Help.vue